import Resource from '@/plugins/sdk/Resource'
import { STRING, ITEM, UUID, DATETIME } from '@/plugins/sdk/fields'
import Type from './Type'

export default class extends Resource {
  static name = 'tracking_level'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      description: new STRING(),
      created_at: new STRING(),
      updated_at: new DATETIME(),
      deleted_date: new DATETIME(),
      type: new ITEM(Type)
    }
  }
}
